module.exports = __webpack_public_path__ + "static/media/boy-down.5e58371c.png";